import { render } from "./CIS-Price-Selector.vue?vue&type=template&id=28c7d1e4&scoped=true"
import script from "./CIS-Price-Selector.vue?vue&type=script&lang=js"
export * from "./CIS-Price-Selector.vue?vue&type=script&lang=js"

import "./CIS-Price-Selector.vue?vue&type=style&index=0&id=28c7d1e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c7d1e4"]])

export default __exports__